import Button from '@r1-frontend/ui-react/components/buttons/button';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

interface IProps {
    btnText: string | undefined,
    onClickContinue: () => void,
}

const SpecialOffer = ({ btnText = 'Продолжить онлайн', onClickContinue }: IProps) => {
    return (
        <ST.SpecialOfferWrapper data-test='special-offer'>
            <Paragraph4 $color={COLORS.TextWhite} data-test='special-offer-title'>
                Доставка и&nbsp;подключение с&nbsp;бонусом&nbsp;&mdash; только при оформлении онлайн
            </Paragraph4>
            <Button
                bType='white'
                onClick={onClickContinue}
                data-test='special-offer-button'
            >
                {btnText}
            </Button>
        </ST.SpecialOfferWrapper>
    );
};

export default SpecialOffer;
